/**
 *
 */
const win: typeof window = import.meta.env.SSR ? (globalThis as never) : window;

if (import.meta.env.SSR) {
  const set = /*                      */ (
    target: Record<PropertyKey, unknown>,
    prop: PropertyKey,
    value: unknown,
  ) => {
    /*                                                                                          */
    target[prop] =
      (typeof value === "object" && value !== null) || typeof value === "function"
        ? new Proxy(value ?? (createTarget() as never), { get, set })
        : value;
    return true;
  };

  const createTarget = () => () => new Proxy(createTarget() as never, { get, set });

  const get = /*                      */ (
    target: Record<PropertyKey, unknown>,
    prop: PropertyKey,
  ): unknown => {
    /*                                                                                        */
    if (target[prop] !== undefined) return target[prop];

    /*                                                  */
    if (import.meta.env.MODE === "test") {
      if (["$$typeof", "_isMockFunction"].includes(prop as string)) return undefined;
      if (prop.toString().startsWith("@@__")) return undefined;
    }

    /*                                                                                                              */
    target[prop] = createTarget()();
    return target[prop];
  };

  /**
 *
 */
  win.o_global ||= get({}, "o_global") as never;
  win.o_util ||= get({}, "o_util") as never;
} else {
  /**
 *
 *
 *
 */
  /*                                                                 */
  win.o_global ||= {} as never;
  win.o_util ||= {} as never;
}

/*                   */
export { win };
export const { o_global, o_util } = win;
